import React, { Component } from 'react';
import { Container, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { data } from '../../constants/Constants';
import icon from '../../assets/img/img-ln.png';
import c from '../../constants/Colors';
import localStorageCustom from '../../utilitarios/localStorage';
import { AuthContext } from "../../store/provider/AuthProvider";
import Spinner from "../reusable/Loader";

export class LineaNegocio extends Component {
  static displayName = LineaNegocio.name;
  static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      lineasNegocio: [],
      linea: {}
    };
  }

  checkParams() {
    this.getLineasNegocio();
    this.setState({ loading: false });
  }

  getLineasNegocio() {
    let result = localStorageCustom.prototype.getUsuario()
    let LineasNegocio = result.dealer.lineasNegocio;
    this.setState({ lineasNegocio: LineasNegocio, loading: false });
  }

  IrLogin = async () => {
    this.props.history.push('/');
  }
  seleccionarLinea = (value) => {
    this.setState({ linea: value })
  }
  postLineaNegocio = () => {
    let storageGeneral = localStorageCustom.prototype.getUsuario();
    storageGeneral.linea = this.state.linea;
    localStorageCustom.prototype.saveUsuario(storageGeneral);
    this.props.history.push({
      pathname: '/razon-social',
      state: {
        LineaNegocio: this.state.linea
      }
    });
    // this.props.navigation.navigate('RazonSocial', { LineaNegocio: this.state.linea });
  }

  componentDidMount() {
    const auth = this.context;
    auth.setIsLoggedIn(false);
    if (localStorageCustom.prototype.getToken() == null) {
      this.props.history.push('/');
    }
    else this.checkParams();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.state != undefined) {
      if (prevProps.location.state !== this.props.location.state) {
        this.checkParams();
      }
    }
  }

  render() {
    const { loading, linea, lineasNegocio } = this.state;
    const navigation = this.props.navigation;
    return (
      <Container className="py-5" id="mhw">
        <Spinner visible={loading} />
        <h4 className='title-2 text-center desktop' style={{ color: c.azulClaro }}>Ingresa a tu cuenta</h4>
        {/* <h4 className="text-center title mb-4 mobile" style={{ color: '#fff' }}>Elige que producto deseas comprar</h4> */}
        <div className="card card_container linea_negocio">
          <img className='logo-small mobile' src={require('../../assets/img/logo-1.png')} />
          <p className="paragraph-1 light" style={{ color: '#8A8A8A' }}>Seleccione la línea de negocio con la que desees trabajar.</p>
          {/* <h6 className="title mb-4 desktop light" style={{ color: c.grisMedio }}>Selecciona la línea de negocio con la que deseas trabajar</h6> */}
          {lineasNegocio.filter(f=>f.linea == data.LineaRepuestos).map((item, index) => {
            return (
              <div className="card-line-negocio" style={{ backgroundColor: item.color }} key={item.id}>
                <div className="custom-control custom-radio custom-control-inline">
                  <input type="radio" id={`radio${item.id}`} name="radio_ln" className="custom-control-input" key={item.id} onChange={() => this.seleccionarLinea(item)} />
                  <label className="custom-control-label" htmlFor={`radio${item.id}`} />
                </div>
                <img src={item.icono} />
                <h6>{item.nombreLinea}</h6>
              </div>
            )
          })}
          <button disabled={(!linea.id)}
            className={`btn-block mobile red${(!linea.id) ? ' disabled' : ''}`}
            onClick={() => this.postLineaNegocio()}>
            aceptar
          </button>
        </div>
        <div className="desktop text-center mt-5">
          <button disabled={(!linea.id)}
            className={`btn-block red${(!linea.id) ? ' disabled' : ''}`}
            onClick={() => this.postLineaNegocio()}>
            aceptar
          </button>
        </div>
      </Container>
    );
  }
}
